import { Action, createReducer, on } from '@ngrx/store';

import * as ApplyPromoCodeActions from './promo-code.actions';
import { PromoCodeDialogAction } from './promo-code.actions';

export const PROMO_CODE_FEATURE_KEY = 'promoCode';

enum RunState {
  IDLE = 'IDLE',
  LOADING = 'LOADING',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR',
}

export interface State {
  promoCode?: string | null;
  loaded: boolean;
  applying: RunState;
  removing: RunState;
  valid?: boolean | null;
  error?: string | null;
  isShowPromoCodeDialog?: boolean | null;
}

export interface ApplyPromoCodePartialState {
  readonly [PROMO_CODE_FEATURE_KEY]: State;
}

export const initialState: State = {
  promoCode: '',
  loaded: false,
  applying: RunState.IDLE,
  removing: RunState.IDLE,
  error: null,
};

const applyPromoCodeReducer = createReducer(
  initialState,
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // ~~~ Handle dialog
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  on(PromoCodeDialogAction.openedDialog, (state) => ({
    ...state,
    isShowPromoCodeDialog: true,
  })),
  on(PromoCodeDialogAction.closeDialog, (state) => ({
    ...state,
    isShowPromoCodeDialog: false,
    applying: RunState.IDLE,
    removing: RunState.IDLE,
    error: null,
  })),
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // ~~ Load Promo Code
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  on(ApplyPromoCodeActions.loadPromoCode, (state) => ({
    ...state,
    loaded: false,
    error: null,
  })),
  on(ApplyPromoCodeActions.loadPromoCodeSuccess, (state, { promoCode }) => ({
    ...state,
    loaded: true,
    promoCode,
  })),
  on(ApplyPromoCodeActions.loadPromoCodeFailure, (state, { error }) => ({
    ...state,
    loaded: false,
    error: error.message,
  })),

  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // ~~ Save Promo Code
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  on(ApplyPromoCodeActions.savePromoCode, (state) => ({
    ...state,
    error: null,
  })),
  on(ApplyPromoCodeActions.savePromoCodeSuccess, (state, { promoCode }) => ({
    ...state,
    promoCode,
  })),
  on(ApplyPromoCodeActions.savePromoCodeFailure, (state, { error }) => ({
    ...state,
    error: error.message,
  })),

  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // ~~ Remove Promo Code
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  on(ApplyPromoCodeActions.removePromoCode, (state) => ({
    ...state,
    error: null,
  })),
  on(ApplyPromoCodeActions.removePromoCodeSuccess, (state) => ({
    ...state,
    promoCode: null,
  })),
  on(ApplyPromoCodeActions.removePromoCodeFailure, (state, { error }) => ({
    ...state,
    error: error.message,
  })),

  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  // ~~ Apply Promo Code
  // ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  on(ApplyPromoCodeActions.applyPromoCodeInit, (state) => ({
    ...state,
    promoCode: null,
    applying: RunState.IDLE,
    error: null,
  })),
  on(ApplyPromoCodeActions.applyPromoCode, (state, { promoCode }) => ({
    ...state,
    promoCode,
    applying: RunState.LOADING,
  })),
  on(ApplyPromoCodeActions.applyPromoCodeSuccess, (state) => ({
    ...state,
    applying: RunState.SUCCESS,
  })),
  on(ApplyPromoCodeActions.applyPromoCodeFailure, (state, { error }) => ({
    ...state,
    applying: RunState.ERROR,
    error: error.message,
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return applyPromoCodeReducer(state, action);
}
